<template>
  <div class="legal-page" :class="theme">
    <nav class="legal-nav">
      <div class="nav-logo">
        <span class="logo-pulse"></span>
        Js<span class="logo-dot">-</span>Werner<span class="logo-dot">.de</span>
      </div>
      <router-link to="/" class="back-home-btn">
        <Icon icon="ph:house" width="18" />
        Startseite
      </router-link>
    </nav>

    <div class="legal-container">
      <h1>Impressum</h1>

      <section class="legal-section">
        <h2>Angaben gemäß § 5 DDG</h2>
        <p>
          Jonathan Sevan Werner<br>
          Wülferoderstraße 27<br>
          30880 Laatzen<br>
          Deutschland
        </p>
      </section>

      <section class="legal-section">
        <h2>Kontakt</h2>
        <p>
          Telefon: 0176 32875205<br>
          E-Mail: mail@js-werner.de
        </p>
      </section>

      <section class="legal-section">
        <h2>Berufsbezeichnung</h2>
        <p>
          Pflegefachkraft in Ausbildung<br>
          Ausbildungsstätte: Vinzenzkrankenhaus Hannover
        </p>
      </section>

      <section class="legal-section">
        <h2>Verantwortlich für den Inhalt nach § 18 Abs. 2 MStV</h2>
        <p>
          Jonathan Sevan Werner<br>
          Wülferoderstraße 27<br>
          30880 Laatzen
        </p>
      </section>

      <section class="legal-section">
        <h2>Urheberrecht</h2>
        <p>
          Die durch den Seitenbetreiber erstellten Inhalte und Werke auf diesen Seiten
          unterliegen dem deutschen Urheberrecht.
        </p>
      </section>

      <section class="legal-section">
        <h2>Webdesign & Entwicklung</h2>
        <p>
          Erstellt von
          <a href="https://zirke-digital.de" target="_blank" rel="noopener noreferrer" class="credit-link">
            <Icon icon="ph:sparkle" width="14" />
            zirke-digital
          </a>
        </p>
      </section>
    </div>
  </div>
</template>

<script>
import { Icon } from '@iconify/vue'

export default {
  name: 'ImpressumView',
  components: { Icon },
  data() {
    return {
      theme: localStorage.getItem('theme') === 'dark' ? 'dark' : 'light'
    }
  }
}
</script>

<style scoped>
.legal-page {
  min-height: 100vh;
  font-family: 'Inter', 'Segoe UI', system-ui, sans-serif;
  transition: background 0.4s, color 0.4s;
}

.legal-page.dark {
  --bg: #15120f;
  --text: #f7f1e8;
  --text-secondary: #cbbfae;
  --accent: #5fd1c4;
  --border: #3d332a;
  --surface: #211c17;
}

.legal-page.light {
  --bg: #fbf7f2;
  --text: #2b2420;
  --text-secondary: #6b5d4f;
  --accent: #1f7a73;
  --border: #e8dfd2;
  --surface: #ffffff;
}

.legal-page {
  background: var(--bg);
  color: var(--text);
}

.legal-nav {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.5rem 3rem;
  border-bottom: 1px solid var(--border);
  background: var(--bg);
  position: sticky;
  top: 0;
  z-index: 10;
}

.nav-logo {
  font-size: 1.4rem;
  font-weight: 800;
  display: flex;
  align-items: center;
  gap: 10px;
}

.logo-pulse {
  width: 10px;
  height: 10px;
  background: var(--accent);
  border-radius: 50%;
  animation: pulse 2s infinite;
}

@keyframes pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.4; transform: scale(1.8); }
}

.logo-dot { color: var(--accent); }

.back-home-btn {
  display: flex;
  align-items: center;
  gap: 8px;
  color: var(--accent);
  font-weight: 600;
  text-decoration: none;
  padding: 0.5rem 1rem;
  border-radius: 50px;
  transition: background 0.2s;
}

.back-home-btn:hover {
  background: var(--surface);
}

.legal-container {
  max-width: 800px;
  margin: 0 auto;
  padding: 4rem 2rem;
}

h1 {
  font-size: 3rem;
  font-weight: 900;
  margin-bottom: 3rem;
  color: var(--accent);
}

.legal-section {
  background: var(--surface);
  border: 1px solid var(--border);
  border-radius: 16px;
  padding: 2rem;
  margin-bottom: 1.5rem;
}

.legal-section h2 {
  font-size: 1.2rem;
  font-weight: 700;
  color: var(--accent);
  margin-bottom: 1rem;
}

.legal-section p {
  color: var(--text-secondary);
  line-height: 1.7;
}

.credit-link {
  color: var(--accent);
  font-weight: 600;
  text-decoration: none;
}

.credit-link:hover {
  text-decoration: underline;
}

@media (max-width: 768px) {
  .legal-nav {
    padding: 1rem 1.5rem;
  }

  h1 {
    font-size: 2rem;
  }

  .legal-section {
    padding: 1.5rem;
  }
}
</style>